
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../App.css";

const AboutInfo = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <div className="about-section padding-container">
      <div className="page-wrapper">
        <div className="about-us">

         {/* What We Do */}
         <div className="about-4" data-aos="fade-up" data-aos-duration="1000">
          <h1>What we <span className="orange-text">Do?</span></h1>
            <p>We provide a complete range of creative, development, and digital growth services:</p>
            <ul>
              <li>Graphic Design & Branding – Social media posts, marketing designs, product assets, and complete brand identity systems.</li>
              <li>UI/UX Design – Wireframing, prototyping, mobile & web app interfaces.</li>
              <li>Website Design & Frontend Development – Professional, responsive websites built with modern technologies.</li>
              <li>FullStack Development – End‑to‑end web solutions including frontend, backend, APIs, and database architecture.</li>
              <li>Mobile App Development – Android, iOS, and cross‑platform mobile applications.</li>
              <li>Motion Graphics & Animation – Promotional videos, explainer animations, logo animations, and visual storytelling.</li>
              <li>SEO Services – On‑page SEO, technical SEO, keyword optimization, and search visibility improvement.</li>
              <li>Digital Marketing – Social media management, paid campaigns, marketing strategy, and brand growth solutions.</li>
            </ul>
          </div>

          {/* Our Mission */}
          <div className="about-2" data-aos="fade-up" data-aos-duration="1000">
          <h1>Our <span className="orange-text">Mission</span></h1>
                      <p>
              To design and develop digital solutions that are visually appealing, 
              user‑friendly, and aligned with our clients’ business goals.
            </p>
          </div>

          {/* Our Vision */}
          <div className="about-3" data-aos="fade-up" data-aos-duration="1000">
          <h1>Our <span className="orange-text">Vision</span></h1>
            <p>
              To become a trusted global partner for businesses seeking creative design, 
              seamless user experiences, and reliable web development.
            </p>
          </div>

         

          {/* Our Approach */}
          <div className="about-5" data-aos="fade-up" data-aos-duration="1000">
          <h1>Our <span className="orange-text">Approach</span></h1>
            <ul>
              <li>We listen, understand, and plan according to your business needs.</li>
              <li>We design with purpose, focusing on clarity and user engagement.</li>
              <li>We build solutions that are scalable, fast, and pixel‑perfect.</li>
              <li>We maintain long‑term partnerships through honest communication and consistent quality.</li>
            </ul>
          </div>

          {/* Our Clients */}
          <div className="about-6" data-aos="fade-up" data-aos-duration="1000">
            <h1>Our <span className="orange-text">Clients</span></h1>
            <p>
              We proudly serve clients worldwide, supporting startups, SMEs, and established brands 
              across multiple industries. Our global partnerships are built on professionalism, 
              quality, and consistent delivery.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutInfo;
